import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from "@angular/core";
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withInterceptors,
} from "@angular/common/http";
import { billingSubscriptionInactiveInterceptor } from "./core/interceptors/billing-subscription-inactive.interceptor";
import { httpToastInterceptor } from "./core/interceptors/http-toast.interceptor";
// import { httpErrorRedirectInterceptor } from "./core/interceptors/http-error-redirect.interceptor";
import { routes } from "./app.routes";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// icons
import { TablerIconsModule } from "angular-tabler-icons";
import * as TablerIcons from "angular-tabler-icons/icons";

// perfect scrollbar
import { NgScrollbarModule } from "ngx-scrollbar";

//Import all material modules
import { MaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideToastr } from "ngx-toastr";

// export function HttpLoaderFactory(http: HttpClient): any {
//   return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
// }

import { authTokenInterceptor } from "./core/interceptors/auth-token.interceptor";
import { opsHttpInspectorInterceptor } from "./core/interceptors/ops-http-inspector.interceptor";
import { QuillModule } from "ngx-quill";
import { provideMaterialDateLocale } from "./shared/providers/material-date-locale.providers";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: false }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
      withComponentInputBinding(),
    ),
    provideHttpClient(
      withInterceptors([
        authTokenInterceptor,
        billingSubscriptionInactiveInterceptor,
        httpToastInterceptor,
        // httpErrorRedirectInterceptor,
        opsHttpInspectorInterceptor,
      ]),
      withInterceptorsFromDi(),
    ),
    provideAnimationsAsync(),
    provideToastr({
      timeOut: 10000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true,
    }),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      TablerIconsModule.pick(TablerIcons),
      NgScrollbarModule,
      TranslateModule.forRoot({
        defaultLanguage: "en",
      }),
      QuillModule.forRoot(),
    ),
    ...provideMaterialDateLocale(),
  ],
};
